import * as React from 'react';
import { Box, Typography, styled } from '@mui/material';
import Column from 'src/frontend-common/components/Column';

const SliderWrapper = styled(Column)(({ theme }) => ({
  background: 'transparent',
  boxShadow: 'none',
  textAlign: 'center',
  height: '100%',
  alignItems: 'center',
  '& h3': {
    fontSize: '27px',
    color: theme.palette.background.paper,
    fontWeight: '500',
  },
  '& p': {
    fontSize: '18px',
    color: theme.palette.background.paper,
    fontWeight: '400',
    maxWidth: 'calc(100% - 40px)',
    [theme.breakpoints.down('lg')]: {},
  },
  '& img': {
    width: '90%',
  },
}));

const SliderItem: React.FC<{
  item: { title: string; subtitle: string; image: string };
}> = ({ item: { title, subtitle, image } }) => (
  <SliderWrapper vAlign="space-around">
    <Box>
      <Typography variant="h3">{title}</Typography>
      <Typography variant="body2">{subtitle}</Typography>
    </Box>
    <Box style={{ position: 'relative', width: '100%' }}>
      <img src={image} />
    </Box>
  </SliderWrapper>
);

export default SliderItem;
